import { chatUpdateMap, updateSet } from "../../utils";

export const initialState = {
  isConnected: false,
  isReconnecting: false,
  connectionError: null,
  isChatModalOpen: false,
  chatOrderId: null,
  chatType: null,
  chatPartnerId: null,
  isAirOrder: false,
  refreshChatCallback: null,
  toastsShown: new Set(),
  openChats: new Map(),
};

export const chatReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONNECTION_STATUS":
      return {
        ...state,
        isConnected: action.payload.connected,
        isReconnecting: action.payload.reconnecting || false,
        connectionError: action.payload.error || null,
      };

    case "RESET_STATE":
      return initialState;

    case "OPEN_CHAT_MODAL":
      return {
        ...state,
        isChatModalOpen: true,
        chatOrderId: action.payload.orderId,
        chatType: action.payload.chatType || "driver-order",
        chatPartnerId: action.payload.partnerId || null,
        isAirOrder: action.payload.isAirOrder || false,
      };

    case "ADD_TOAST_SHOWN":
      return {
        ...state,
        toastsShown: updateSet(state.toastsShown, action.payload.orderId, "add"),
      };

    case "REMOVE_TOAST_SHOWN":
      return {
        ...state,
        toastsShown: updateSet(state.toastsShown, action.payload.orderId, "delete"),
      };

    case "REGISTER_CHAT":
      const updatedOpenChats = chatUpdateMap(state.openChats, action.payload.orderId, "set", {
        refreshCallback: action.payload.refreshCallback,
        isModalChat: action.payload.isModalChat || false,
      });
      return {
        ...state,
        openChats: updatedOpenChats,
      };

    case "UNREGISTER_CHAT":
      return {
        ...state,
        openChats: chatUpdateMap(state.openChats, action.payload.orderId, "delete"),
      };

    case "SET_REFRESH_CALLBACK":
      return {
        ...state,
        refreshChatCallback: action.payload.callback,
      };

    case "CLOSE_CHAT_MODAL":
      return {
        ...state,
        isChatModalOpen: false,
        chatOrderId: null,
        chatType: null,
        chatPartnerId: null,
        isAirOrder: false,
        refreshChatCallback: null,
        toastsShown: state.chatOrderId
          ? updateSet(state.toastsShown, state.chatOrderId, "delete")
          : state.toastsShown,
        openChats: state.chatOrderId
          ? chatUpdateMap(state.openChats, state.chatOrderId, "delete")
          : state.openChats,
      };

    default:
      return state;
  }
};
